// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';

const reducers = combineReducers({ menu });

export default reducers;
